import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";

const blogPosts = [
  {
    title: "Introducing Boxia Tab",
    date: "2025-11-11",
    excerpt:
      "The fastest, smartest AI autocomplete system ever built, designed to feel invisible until you need it.",
    slug: "introducing-boxia-tab",
    authors: "Radin Reth and Ian Murphy",
  },
  {
    title: "Top 5 Calendar Apps in 2025 (Full Comparison)",
    date: "2025-11-10",
    excerpt:
      "Our 2025 breakdown of the best calendar tools—why Boxia’s unified workspace beats Google, Outlook, Notion & others.",
    slug: "top-5-calendar-apps-2025",
    authors: "Boxia Team",
    hidden: true,
  },
  {
    title: "Best Calendar for Remote Teams in 2025",
    date: "2025-11-10",
    excerpt:
      "How distributed teams reduce context switching: Boxia vs Google + Slack vs Notion configurations.",
    slug: "best-calendar-for-remote-teams-2025",
    authors: "Boxia Team",
    hidden: true,
  },
  {
    title: "Boxia vs Google Calendar (2025)",
    date: "2025-11-10",
    excerpt:
      "Feature-by-feature breakdown: events as context anchors, AI scheduling, privacy, and workflow speed.",
    slug: "boxia-vs-google-calendar-2025",
    authors: "Boxia Team",
    hidden: true,
  },
];

const BlogPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <main
        className="flex-grow bg-white dark:bg-[#1a1a1a] transition-colors duration-300 relative overflow-x-hidden"
        style={{
          background:
            "radial-gradient(ellipse 60% 80% at 50% 0%, rgba(120,119,198,0.10), rgba(255,255,255,0)), radial-gradient(ellipse 60% 80% at 50% 0%, rgba(120,119,198,0.18), rgba(26,26,26,0))",
        }}
      >
        {/* Hero Section */}
        <section className="relative pt-[160px] bg-transparent">
          <div className="relative max-w-screen-xl z-10 mx-auto px-4 py-20 md:px-8">
            <div className="space-y-5 max-w-3xl mx-auto text-center">
              <h1 className="text-sm text-gray-600 dark:text-gray-400 group font-geist mx-auto px-5 py-2 bg-gradient-to-tr from-zinc-300/20 via-gray-400/20 to-transparent dark:from-zinc-300/5 dark:via-gray-400/5 border-[2px] border-black/5 dark:border-white/5 rounded-xl w-fit">
                Blog
              </h1>
              <h2 className="text-4xl tracking-tighter font-geist bg-clip-text text-transparent mx-auto md:text-6xl bg-[linear-gradient(180deg,_#000_0%,_rgba(0,_0,_0,_0.75)_100%)] dark:bg-[linear-gradient(180deg,_#FFF_0%,_rgba(255,_255,_255,_0.00)_202.08%)]">
                {/* NOTE: Removed background-clip gradient from full heading due to clipping/cutoff of top glyphs (especially on Safari) when using large font sizes with custom font-geist. Keeping gradient accent only on brand word. */}
                <span className="block overflow-visible leading-[1.08] text-gray-900 dark:text-gray-100">
                  Insights & Updates from
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500 dark:from-purple-300 dark:to-orange-200 ml-2">
                    Boxia
                  </span>
                </span>
              </h2>
              <p className="max-w-2xl mx-auto text-gray-600 dark:text-gray-300">
                The latest news, stories, and tips from the Boxia team.
              </p>
            </div>
          </div>
        </section>

        {/* Blog Posts Grid */}
        <section className="relative bg-transparent">
          <div className="relative max-w-screen-xl z-10 mx-auto px-4 pb-28 md:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.filter(p => !p.hidden).map((post) => (
                <div
                  key={post.slug}
                  className="group relative overflow-hidden rounded-xl border-[1px] border-black/5 dark:border-white/5 bg-gradient-to-tr from-zinc-300/20 via-gray-400/20 to-transparent dark:from-zinc-300/5 dark:via-gray-400/5 p-8 flex flex-col justify-between shadow-sm hover:shadow-xl transition-all duration-300"
                >
                  <div>
                    <h3 className="text-2xl font-semibold mb-2 text-gray-900 dark:text-gray-100 font-geist group-hover:text-purple-600 dark:group-hover:text-purple-300 transition-colors duration-300">
                      {post.title}
                    </h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
                      {new Date(post.date).toLocaleDateString()}
                    </p>
                    <p className="text-gray-700 dark:text-gray-300 mb-6">
                      {post.excerpt}
                    </p>
                  </div>
                  <a
                    href={`/blog/${post.slug}`}
                    className="inline-block mt-auto text-purple-600 dark:text-purple-300 hover:text-pink-500 dark:hover:text-orange-200 font-medium transition-colors duration-300"
                  >
                    Read more →
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;
